import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { v2ErrorMessage } from '../../../shared/utils/v2-api-response.util';
import {
  CreditKind,
  CreditListFilter,
  CreditListResult,
  EMPTY_CREDIT_LIST_SUMMARY,
} from '../models/credit-shared.model';

@Injectable({ providedIn: 'root' })
export class CreditListReadService {

  constructor(private http: HttpClient) { }

  list(kind: CreditKind, filter: CreditListFilter): Promise<CreditListResult> {
    const path = kind === 'employee' ? '/api/v2/employee-credits' : '/api/v2/credits';
    const fallback = kind === 'employee'
      ? 'No se pudo cargar la lista de créditos con empleados'
      : 'No se pudo cargar la lista de créditos';

    return firstValueFrom(this.http.post<any>(`${environment.apiUrl}${path}/list`, filter))
      .catch(error => {
        throw { status: error && error.status, error: { message: v2ErrorMessage(error && error.error, fallback) } };
      })
      .then(response => {
        if (!response || response.isSuccess === false) {
          throw { error: { message: v2ErrorMessage(response, fallback) } };
        }
        return {
          items: Array.isArray(response.values) ? response.values : [],
          total: Number(response.total) || 0,
          summary: response.summary || { ...EMPTY_CREDIT_LIST_SUMMARY },
        };
      });
  }
}
